import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const PostsStatusDonut = ({data, height = 280}) => {

    // const seriesData = [
    //     {
    //         name: "Posts Missed",
    //         y: 22,
    //         color: "#FF4040",
    //     },
    //     {
    //         name: "Posts Delivered",
    //         y: 6,
    //         color: "#0095FF",
    //     },
    // ]

  const options = {
    chart: {
      type: "pie",
      height: height,
      backgroundColor: "transparent",
    },

    title: {
      text: null,
    },

    tooltip: {
      enabled: false,
    },

    plotOptions: {
      pie: {
        innerSize: "60%", // donut thickness
        borderWidth: 4,
        borderColor: "#fff",
        borderRadius: 4, // 👈 THIS rounds the slice ends
        dataLabels: {
          enabled: true,
          useHTML: true,
          connectorWidth: 2,
          connectorColor: "#ccc",
          style: {
            fontSize: "14px",
            fontWeight: "500",
          },
          formatter() {
            return `<b>${this.point.name}</b> (${this.label ?? this.y})`;
          },
        },
      },
    },

    series: [
      {
        data: data,
      },
    ],

    credits: {
      enabled: false,
    },

    legend: {
      enabled: false,
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default PostsStatusDonut;
